import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DevelopersMainComponent } from './components/main/developers-main.component';
import { DevelopersRoutes } from './models/developers-routes';

export const routes: Routes = [
  // {
  //   path: DevelopersRoutes.DynamicData,
  //   loadChildren: () => import('./modules/dynamic-catalog/dynamic-catalog.module').then(x => x.DynamicCatalogModule)
  // },
  {
    path: DevelopersRoutes.Statics,
    loadChildren: () => import('./modules/statistics/statistics.module').then(x => x.StatisticsModule)
  },
  {
    path: DevelopersRoutes.UseApi,
    loadChildren: () => import('./modules/use-api/use-api.module').then(x => x.UseApiModule)
  },
  {
    path: DevelopersRoutes.Documentation,
    loadChildren: () => import('./modules/doc/doc.module').then(x => x.DocModule)
  },
  {
    path: '',
    component: DevelopersMainComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DevelopersRoutingModule {}
